import React from 'react'

export default function App({ children }) {
  return (
    <div>{children}</div>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/App.js